var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('form-loader');
import { breakpoints, theme } from '@shapeable/theme';
import { ClipLoader as Spinner } from 'react-spinners';
import { useLang } from '../../hooks/use-lang';
export var FormLoaderDefaultProps = {
  size: 60,
  color: '#FFF'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,0.8);\n    padding: ", ";\n    box-sizing: border-box;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,0.8);\n    padding: ", ";\n    box-sizing: border-box;\n    ", "\n  "])), theme.UNIT(4), function (_a) {
    var color = _a.color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), color);
  })
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MessageStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    margin-top: ", ";\n  "])), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Spinner: styled(Spinner)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  Message: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
export var FormLoader = function FormLoader(props) {
  var className = props.className,
      children = props.children,
      size = props.size,
      color = props.color;
  var t = useLang();
  return React.createElement(My.Container, {
    color: color,
    className: cls.name(className)
  }, React.createElement(My.Spinner, {
    size: size,
    color: color
  }), React.createElement(My.Message, null, children || t('Please wait...')));
};
FormLoader.defaultProps = FormLoaderDefaultProps;
FormLoader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;